import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'
import { ThemedShared } from 'styles/themed'

export const styles = StyleSheet.create({
	buttonIconIconContainer: {
		width: 50,
		height: 50,
		//position: 'absolute',
		//left: 0,
		//right: 0,
		//bottom: 0,
		//top: 0,
		justifyContent: 'center',
		alignItems: 'center',
	},
	
	icon: {
		color: colorList.PRIMARY.dark,
		fontSize: 24
	},
	
	button: {
		marginBottom: ThemedShared.paddingSmall.padding
	},
	buttonTextStyle: {
		textAlign: 'left'
	},
	divider: {
		marginTop: ThemedShared.paddingMedium.padding,
		marginBottom: ThemedShared.paddingMedium.padding
	},
	customerName: {
		fontSize: 12,
		fontWeight: '700',
		textAlign: 'center',
		marginTop: 12,
		marginBottom: 0
	},
	privacy:{
		fontSize: 12,
		fontWeight: '700',
		textAlign: 'center',
		marginTop: 0,
		marginBottom: 12,
		textDecorationLine: 'underline'
	},
	modTime: {
		fontSize: 12,
		color: colorList.GREY.dark,
		fontWeight: '700',
		textAlign: 'center',
		marginTop: 6,
		marginBottom: 12,
	},
	modVersion: {
		fontSize: 12,
		fontWeight: '700',
		textAlign: 'center'
	},
	modVersionUpdate:{
		fontSize: 12,
		textAlign: 'center',
		textDecorationLine: 'underline'
	},
	modVersionUpdateProgress: {
		alignItems: 'center',
		paddingTop: 8
	},
	
	debug: {
		fontSize: 12,
		fontWeight: '700',
		color: colorList.RED.primary,
		textDecorationLine: 'underline',
		textAlign: 'center',
		padding: ThemedShared.paddingSmall.padding
	}
});
